import type { OrderedMap } from 'immutable';

import type Organization from 'entities/organization/model';

export const ADD_MULTIPLE = 'entities/organization/ADD_MULTIPLE';
export const ADD = 'entities/organization/ADD';
export const SET_DISPLAYED_ORGANIZATION_IDS = 'entities/organization/SET_DISPLAYED_DONATION_IDS';

export const addAction = (
  organization: Organization
): { type: typeof ADD; organization: Organization } => ({
  type: ADD,
  organization,
});

export const addMultipleAction = (
  organizations: OrderedMap<string, Organization>
): { type: typeof ADD_MULTIPLE; organizations: OrderedMap<string, Organization> } => ({
  type: ADD_MULTIPLE,
  organizations,
});

export const setDisplayedOrganizationIdsAction = (
  organizationIds: string[]
): { type: typeof SET_DISPLAYED_ORGANIZATION_IDS; organizationIds: string[] } => ({
  type: SET_DISPLAYED_ORGANIZATION_IDS,
  organizationIds,
});
